import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a02ba54"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "large-title"
}
const _hoisted_2 = { key: 0 }

import { BigNumber } from '@ethersproject/bignumber';
import { computed } from 'vue';
import {
  DisplayPlatform,
  getPlatformLink,
  PLATFORM_DISPLAY_ORDER,
  PLATFORM_DISPLAY_PROPS,
} from '@/common/platforms';
import TrackedLink from '@/components/tracking/TrackedLink.vue';
import { TELEMETRY_MAPPING } from '@/lib/telemetry';
import { useClaimStore } from '@/store/claimStore';

interface PlatformTrackedLink {
  label: string;
  link: string;
  imageProps: (typeof PLATFORM_DISPLAY_PROPS)[DisplayPlatform]['imageProps'];
  onClick: () => void;
}

interface PlatformLinksProps {
  label?: string;
  creatorContractAddress: string;
  tokenId: BigNumber | null;
  is1155: boolean;
  hasMints: boolean;
  postCheckout?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PlatformLinks',
  props: {
    label: {},
    creatorContractAddress: {},
    tokenId: {},
    is1155: { type: Boolean },
    hasMints: { type: Boolean },
    postCheckout: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

_useCssVars(_ctx => ({
  "c351353a": (platformLinkCount.value)
}))



/** platforms to display. filters out foundation if erc1155 */
const platforms = computed(() => {
  const platforms: PlatformTrackedLink[] = [];
  if (!props.hasMints && !props.is1155) {
    // can't display links if is erc721 and has no mints
    return platforms;
  }

  const platformsToDisplay = props.postCheckout
    ? PLATFORM_DISPLAY_ORDER
    : [DisplayPlatform.Manifold];

  for (const platform of platformsToDisplay) {
    if (platform === DisplayPlatform.OpenSea && props.is1155 && !props.hasMints) {
      // Skip OpenSea for ERC1155 tokens without mints
      continue;
    }

    // Foundation doesn't support 1155
    if (platform === DisplayPlatform.Foundation && props.is1155) {
      continue;
    }

    const platformProps = PLATFORM_DISPLAY_PROPS[platform];

    if (platformProps.networks.includes(store.networkId)) {
      platforms.push({
        label: platform,
        link: getPlatformLink(
          platform,
          store.networkId,
          props.creatorContractAddress,
          tokenId1155.value,
          props.postCheckout
        ),
        imageProps: {
          ...platformProps.imageProps,
          src: require(`@/assets/images/${platformProps.imageProps.src}`),
        },
        onClick: () => handlePlatformClick(platform),
      });
    }
  }
  return platforms;
});

// Computer now so that the grid (see CSS below looks correct / has number of squares.)
const platformLinkCount = computed<number>(() => {
  return platforms.value.length;
});

const store = useClaimStore();

const tokenId1155 = computed<string | null>(() => {
  const tokenId = props.tokenId;
  // TODO: is this like -1?
  if (
    tokenId &&
    !tokenId.eq(
      BigNumber.from('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
    )
  ) {
    return tokenId.toString();
  }
  return null;
});

const handlePlatformClick = (platform: DisplayPlatform) => {
  if (platform === DisplayPlatform.Manifold) {
    store.analytics.capture({
      event: TELEMETRY_MAPPING.mintFlow.VIEW_ON_MANIFOLD_BUTTON_CLICK,
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.postCheckout)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(props.label || 'View on Platforms'), 1))
      : _createCommentVNode("", true),
    (props.hasMints || props.is1155)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({
          key: 1,
          class: [_ctx.postCheckout ? 'large' : '', 'campaign-platform-links'],
          "data-test": "platform-links"
        }, _ctx.$attrs), [
          (!_ctx.postCheckout)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.label || 'View on Manifold'), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platforms.value, (platform) => {
            return (_openBlock(), _createBlock(TrackedLink, {
              key: platform.label,
              label: platform.label,
              target: "_blank",
              href: platform.link,
              onClick: platform.onClick
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", _normalizeProps(_guardReactiveProps(platform.imageProps)), null, 16)
              ]),
              _: 2
            }, 1032, ["label", "href", "onClick"]))
          }), 128))
        ], 16))
      : _createCommentVNode("", true)
  ], 64))
}
}

})